module.exports = __webpack_public_path__ + "img/memberBuy.30708774.svg";